import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
export default function PropertyPreview({ property }) {
  return (
    <Link to={`/portfolio#${property.id}`} className="site-property-preview">
      <div className="site-property-photo">
        <img
          src={property.image}
          alt={`${property.name} residential architecture in ${property.area}`}
          loading="lazy"
          width="600"
          height="750"
        />
      </div>
      <div className="site-property-caption">
        <div>
          <h3>{property.name}</h3>
          <p>{property.area}</p>
        </div>
        <ArrowUpRight aria-hidden="true" />
      </div>
    </Link>
  );
}
